import { useState } from 'react';
import SEOMeta from '../../components/SEOMeta';
import { WHATSAPP_CTA_URL } from '../../data/whatsapp';

const C = {
  cream: 'var(--cream)',
  warmWhite: 'var(--warm-white)',
  earth: 'var(--earth)',
  earthLight: 'var(--earth-light)',
  gold: 'var(--gold)',
  goldPale: 'var(--gold-pale)',
  beigeMid: 'var(--beige-mid)',
  textBody: 'var(--text-body)',
  textMuted: 'var(--text-muted)',
  beige: 'var(--beige-footer)',
};

const faqs = [
  {
    question: 'Como funciona a música personalizada?',
    answer:
      'Você conta a história de quem quer homenagear, escolhe o estilo musical, ouve uma prévia e escolhe o plano que faz mais sentido para o presente. Depois da confirmação do pagamento, a entrega acontece pelo WhatsApp informado no pedido.',
  },
  {
    question: 'Quanto custa uma música personalizada?',
    answer:
      'Você escolhe entre Música por R$ 34,90 ou Música + Vídeo com Fotos por R$ 49,90. Os dois incluem uma música personalizada; o segundo acrescenta um vídeo profissional com todas as fotos válidas enviadas.',
  },
  {
    question: 'Quanto tempo demora para receber a música?',
    answer:
      'Os dois pacotes ficam prontos em até 30 minutos após a confirmação do pagamento e, no pacote com vídeo, após o envio das fotos.',
  },
  {
    question: 'Posso escolher o estilo musical?',
    answer:
      'Sim! Temos mais de 25 estilos disponíveis: Sertanejo, MPB, Gospel, Pop, Forró, Pagode, Bossa Nova, Rock e muitos outros. Você escolhe também a voz — masculina ou feminina.',
  },
  {
    question: 'E se eu não gostar da música?',
    answer:
      'Oferecemos garantia de 100% de satisfação. Se a primeira prévia não representar bem a sua história, usamos o seu feedback e refazemos a música sem custo.',
  },
  {
    question: 'Para quais ocasiões posso criar uma música?',
    answer:
      'Para qualquer ocasião: Dia das Mães, aniversários, casamento, Natal, Dia dos Namorados, formaturas, homenagens, batizados, chá revelação — ou simplesmente para dizer "eu te amo".',
  },
  {
    question: 'A música é realmente exclusiva?',
    answer:
      'Sim, 100% exclusiva. A letra é criada com base na história que você nos conta sobre a pessoa homenageada. Nenhuma música é igual a outra.',
  },
  {
    question: 'Qual o melhor presente criativo para minha mãe?',
    answer:
      'A música personalizada é o presente ideal, pois transforma a história de vocês em uma melodia inesquecível. É muito mais emocionante que presentes comuns, pois carrega suas melhores memórias e toca o coração.',
  },
  {
    question: 'Existe algum presente que faz a pessoa chorar de emoção?',
    answer:
      'Sim, músicas pautadas em histórias reais costumam emocionar profundamente. Quando a pessoa que você ama ouve o próprio nome e detalhes da vida dela cantados no estilo musical preferido, a surpresa e as lágrimas de alegria são garantidas.',
  },
  {
    question: 'O que dar de presente de aniversário para alguém que tem de tudo?',
    answer:
      'Uma música exclusiva. Bens materiais não surpreendem tanto quem já "tem de tudo", mas uma experiência emocional única, onde você conta a história de vocês através de uma canção, é algo que não tem preço e jamais será esquecido.',
  },
  {
    question: 'A música é entregue em qual formato?',
    answer:
      'Você recebe a música em formato de áudio de alta qualidade. Ela é perfeita para ser ouvida no celular, no carro, enviada nos grupos de família ou até mesmo usada como fundo de vídeos especiais e retrospectivas.',
  },
  {
    question: 'Posso compartilhar a música nas minhas redes sociais?',
    answer:
      'Com certeza! A música é sua. Você pode publicar no Instagram, TikTok, enviar pelo WhatsApp para os familiares e usar como trilha sonora dos momentos especiais.',
  },
  {
    question: 'Vocês criam a música a partir de um poema ou letra minha?',
    answer:
      'Nosso processo é todo baseado nas histórias e emoções que você nos conta. Você só precisa descrever sobre a pessoa e o que sente por ela; a partir daí, nossa equipe se encarrega de criar uma letra e melodia impressionantes do zero para você.',
  },
  {
    question: 'É seguro pagar via PIX? E se meu pagamento não for reconhecido?',
    answer:
      'É 100% seguro. Usamos um processador de pagamentos bancário homologado em todo o Brasil. Seu PIX costuma ser aprovado em poucos segundos e o processo de criação começa na mesma hora.',
  },
  {
    question: 'Vocês cantam o nome da pessoa homenageada na música?',
    answer:
      'Sim! O nome da pessoa fará parte da letra. Ao preencher os dados do pedido, basta nos dizer como ela se chama e nós cuidaremos para que a música seja perfeitamente dedicada a ela.',
  },
  {
    question: 'Posso fazer uma música como presente de casamento?',
    answer:
      'Sim, é um dos nossos pedidos que mais emocionam! É perfeito para os noivos entrarem na festa ou para ser uma surpresa dos pais e padrinhos que desejam dar o presente mais inesquecível celebrando a história de amor.',
  },
  {
    question: 'Meu pedido pode ser para um grupo de amigos ou para toda a família?',
    answer:
      'Sim. Em nosso formulário, basta informar no campo de "Para quem" que se trata da família ou de amigos. A letra será conduzida no tom e contexto perfeito para um grupo.',
  },
  {
    question: 'Como escolher o melhor estilo musical?',
    answer:
      'Pense nos artistas ou no ritmo que a pessoa homenageada mais gosta de escutar no dia a dia. Se ela é animada, algo como Pop, Pagode ou Forró. Se for romântica, MPB, Bossa Nova ou Sertanejo raiz. A voz e o ritmo combinam perfeitamente com a escolha.',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: f.answer,
    },
  })),
};

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        borderBottom: `1px solid ${C.beigeMid}`,
        padding: '0',
      }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 0',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          gap: 16,
        }}
        aria-expanded={open}
      >
        <span
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 17,
            fontWeight: 500,
            color: C.earth,
            lineHeight: 1.4,
          }}
        >
          {question}
        </span>
        <span
          style={{
            flexShrink: 0,
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: open ? C.gold : C.goldPale,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.2s',
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            style={{
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            <path
              d="M2 5l5 5 5-5"
              stroke={open ? '#fff' : C.gold}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      {open && (
        <p
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 15,
            color: C.textBody,
            lineHeight: 1.7,
            paddingBottom: 20,
            margin: 0,
          }}
        >
          {answer}
        </p>
      )}
    </div>
  );
}

export default function FAQPage() {
  return (
    <>
      <SEOMeta
        title="Perguntas Frequentes sobre Música Personalizada | Inspira Músicas"
        description="Tire suas dúvidas sobre como funciona, quanto custa, prazo de entrega e garantia das músicas personalizadas do Inspira Músicas."
        path="/faq"
        jsonLd={faqSchema}
      />

      <div
        style={{
          minHeight: '100vh',
          background: C.cream,
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        {/* Header simples */}
        <header
          style={{
            background: C.warmWhite,
            borderBottom: `1px solid ${C.beigeMid}`,
            padding: '16px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <a
            href="/"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 20,
              fontWeight: 700,
              color: C.earth,
              textDecoration: 'none',
            }}
          >
            Inspira Músicas
          </a>
          <a
            href={WHATSAPP_CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: C.gold,
              color: '#fff',
              padding: '10px 20px',
              borderRadius: 100,
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            Criar música
          </a>
        </header>

        {/* Hero */}
        <section
          style={{
            background: C.goldPale,
            padding: '64px 24px 48px',
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: C.gold,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginBottom: 12,
            }}
          >
            Tire suas dúvidas
          </p>
          <h1
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(28px, 5vw, 44px)',
              fontWeight: 700,
              color: C.earth,
              margin: '0 0 16px',
              lineHeight: 1.2,
            }}
          >
            Perguntas Frequentes
          </h1>
          <p
            style={{
              fontSize: 17,
              color: C.earthLight,
              maxWidth: 520,
              margin: '0 auto',
              lineHeight: 1.6,
            }}
          >
            Tudo que você precisa saber antes de criar uma música especial para alguém que você ama.
          </p>
        </section>

        {/* FAQ list */}
        <section
          style={{
            maxWidth: 720,
            margin: '0 auto',
            padding: '48px 24px 80px',
          }}
        >
          {faqs.map((f, i) => (
            <FAQItem key={i} question={f.question} answer={f.answer} />
          ))}

          {/* CTA */}
          <div
            style={{
              marginTop: 56,
              background: C.warmWhite,
              border: `1px solid ${C.beige}`,
              borderRadius: 16,
              padding: '40px 32px',
              textAlign: 'center',
            }}
          >
            <p
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 22,
                fontWeight: 700,
                color: C.earth,
                marginBottom: 8,
              }}
            >
              Ainda tem dúvidas?
            </p>
            <p
              style={{
                fontSize: 15,
                color: C.textMuted,
                marginBottom: 24,
                lineHeight: 1.6,
              }}
            >
              Fale com a gente pelo WhatsApp — respondemos na hora.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <a
                href={WHATSAPP_CTA_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: C.gold,
                  color: '#fff',
                  padding: '14px 28px',
                  borderRadius: 100,
                  textDecoration: 'none',
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                Criar minha música
              </a>
              <a
                href="https://wa.me/5511XXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: `1.5px solid ${C.earth}`,
                  color: C.earth,
                  padding: '14px 28px',
                  borderRadius: 100,
                  textDecoration: 'none',
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </section>

        {/* Footer simples */}
        <footer
          style={{
            background: C.beige,
            padding: '24px',
            textAlign: 'center',
            fontSize: 13,
            color: C.textMuted,
          }}
        >
          © 2025 Inspira Músicas — AUTOMAT TECNOLOGIA DA INFORMACAO LTDA · CNPJ 59.640.197/0001-76
          <br />
          <a href="/privacidade" style={{ color: C.textMuted, marginRight: 12 }}>Privacidade</a>
          <a href="/termos" style={{ color: C.textMuted }}>Termos</a>
        </footer>
      </div>
    </>
  );
}
